import { render, staticRenderFns } from "./AddEntity.vue?vue&type=template&id=1409898b&"
import script from "./AddEntity.vue?vue&type=script&lang=ts&"
export * from "./AddEntity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports